(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/components/reference-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/components/reference-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const REFERENCE = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.constants.names.REFERENCE;
const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.constants.TEXTS.REFERENCE,
  LABEL = _svs$ticket_partner$d.LABEL,
  MAX = _svs$ticket_partner$d.MAX,
  MAX_ERROR = _svs$ticket_partner$d.MAX_ERROR,
  REQUIRED_ERROR = _svs$ticket_partner$d.REQUIRED_ERROR;
const Reference = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state;
  return React.createElement(TextInput, {
    errorMessageMax: MAX_ERROR,
    errorMessageRequired: REQUIRED_ERROR,
    id: REFERENCE,
    isRequired: true,
    label: LABEL,
    max: MAX,
    name: REFERENCE,
    onChange: handleChange,
    value: state[REFERENCE]
  });
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.components.Reference = Reference;

 })(window);